<template>
  <div>
    <!-- ローディングダイアログ -->
    <DialogLoading ref="DialogLoading" />

    <!-- 認証成功 -->
    <DialogValidFramesWithEmergencyCodeComplete
      ref="DialogValidFramesWithEmergencyCodeComplete"
    />

    <!-- 認証失敗 -->
    <DialogValidFramesWithEmergencyCodeFails
      ref="DialogValidFramesWithEmergencyCodeFails"
    />

    <!-- UseInterval内のため使用不可ダイアログ -->
    <DialogInvalidUseInterval ref="DialogInvalidUseInterval" />

    <!-- 複数利用制限のダイアログ -->
    <DialogAlreadyValidatedAnother ref="DialogAlreadyValidatedAnother" />

    <!-- 複数利用制限のダイアログ -->
    <DialogMaxConcurrentUsingOver ref="DialogMaxConcurrentUsingOver" />
  </div>
</template>

<script>
import DialogLoading from "@/views/Components/Organisms/Common/Dialog/DialogLoading";
import DialogAlreadyValidatedAnother from "@/views/Components/Organisms/MyTickets/Dialog/DialogAlreadyValidatedAnother";
import DialogMaxConcurrentUsingOver from "@/views/Components/Organisms/MyTickets/Dialog/DialogMaxConcurrentUsingOver";
import DialogValidFramesWithEmergencyCodeComplete from "@/views/Components/Organisms/MyTickets/Dialog/DialogValidFramesWithEmergencyCodeComplete";
import DialogValidFramesWithEmergencyCodeFails from "@/views/Components/Organisms/MyTickets/Dialog/DialogValidFramesWithEmergencyCodeFails";
import DialogInvalidUseInterval from "@/views/Components/Organisms/MyTickets/Dialog/DialogInvalidUseInterval";

import { onMounted, computed, watch, watchEffect, ref } from "vue";

export default {
  name: "TheSheetEmergencyCodeDialogs",
  props: {
    openedDialogName: {
      type: String,
    },
  },
  setup(props) {
    const DialogLoading = ref(null);
    const DialogAlreadyValidatedAnother = ref(null);
    const DialogMaxConcurrentUsingOver = ref(null);
    const DialogValidFramesWithEmergencyCodeComplete = ref(null);
    const DialogValidFramesWithEmergencyCodeFails = ref(null);
    const DialogInvalidUseInterval = ref(null);

    watch(
      () => props.openedDialogName,
      (newDialogName, oldDialogName) => {
        // 現在開いているダイアログがあれば閉じる
        if (oldDialogName != "") {
          eval(oldDialogName).value.closeDialog();
        }
        eval(newDialogName).value.openDialog();
      }
    );

    return {
      DialogLoading,
      DialogAlreadyValidatedAnother,
      DialogMaxConcurrentUsingOver,
      DialogValidFramesWithEmergencyCodeComplete,
      DialogValidFramesWithEmergencyCodeFails,
      DialogInvalidUseInterval,
    };
  },
};
</script>
